import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBackBlackIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"data-rtl-mirror": "true",
	width: 18,
	height: 12,
	viewBox: "0 0 18 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.80078 7.00078L6.70078 9.90078C6.88411 10.0841 6.97578 10.3174 6.97578 10.6008C6.97578 10.8841 6.88411 11.1174 6.70078 11.3008C6.51745 11.4841 6.28411 11.5758 6.00078 11.5758C5.71745 11.5758 5.48411 11.4841 5.30078 11.3008L0.700781 6.70078C0.600781 6.60078 0.529948 6.49245 0.488281 6.37578C0.446615 6.25911 0.425781 6.13411 0.425781 6.00078C0.425781 5.86745 0.446615 5.74245 0.488281 5.62578C0.529948 5.50911 0.600781 5.40078 0.700781 5.30078L5.30078 0.700781C5.48411 0.517448 5.71745 0.425781 6.00078 0.425781C6.28411 0.425781 6.51745 0.517448 6.70078 0.700781C6.88411 0.884115 6.97578 1.11745 6.97578 1.40078C6.97578 1.68411 6.88411 1.91745 6.70078 2.10078L3.80078 5.00078H17.0008C17.2841 5.00078 17.5216 5.09661 17.7133 5.28828C17.9049 5.47995 18.0008 5.71745 18.0008 6.00078C18.0008 6.28411 17.9049 6.52161 17.7133 6.71328C17.5216 6.90495 17.2841 7.00078 17.0008 7.00078H3.80078Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgArrowBackBlackIcon);
export default ForwardRef;
